import { render, staticRenderFns } from "./successMain.vue?vue&type=template&id=87cd51fe&scoped=true"
import script from "./successMain.vue?vue&type=script&lang=js"
export * from "./successMain.vue?vue&type=script&lang=js"
import style0 from "./successMain.vue?vue&type=style&index=0&id=87cd51fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cd51fe",
  null
  
)

export default component.exports